import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator, MatSnackBar, PageEvent } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PxaDialogComponent } from './pxa-dialog/pxa-dialog.component';
import { PxaSimuladorComponent } from './pxa-simulador/pxa-simulador.component';
import { PxaAuditoriaComponent } from './pxa-auditoria/pxa-auditoria.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-pxa',
  templateUrl: './pxa.component.html',
  styleUrls: ['./pxa.component.scss']
})
export class PxaComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  puedeCrear = true;
  puedeEditar = true;
  puedeBorrar = true;

  displayedColumns: string[] = ['priority', 'exchange_id', 'department_code', 'source_application', 'employee_id', 'pxa', 'fr', 'ag', 'ACCION'];
  dataSource = new MatTableDataSource<any>([]);

  private subscription: Subscription;
  private subscriptioncreate: Subscription;

  FILTER;
  resultsLength = 0;
  pageSize = 10;
  pageEvent: PageEvent;
  public actpage: number = 0;

  // Filtros avanzados
  filtroExchangeId: string = '';
  filtroDepartmentCode: string = '';
  filtroSourceApplication: string = '';
  filtroPxa: string = '';
  filtroFr: string = '';
  filtroAg: string = '';

  @ViewChild('paginatorpxa') paginatorpxa: MatPaginator;
  @ViewChild('uploadfilePxa') uploadfilePxa;

  constructor(
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar
  ) { }

  private _tienePermiso(modulo: string, tipo: string = 'ver'): boolean {
    const user = this.localSave.get('usuarioPGV');
    if (!user || !user.permisos) return false;
    const perm = user.permisos.find(p => p.modulo === modulo);
    return perm ? perm['permiso_' + tipo] === 1 : false;
  }

  ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    if (user && user.idrol >= 28) {
      this.puedeCrear = this._tienePermiso('PAGO_ADELANTADO', 'crear');
      this.puedeEditar = this._tienePermiso('PAGO_ADELANTADO', 'editar');
      this.puedeBorrar = this._tienePermiso('PAGO_ADELANTADO', 'borrar');
    }
    this.pageTitle.title = 'Parametros Pago Adelantado';
    this.get(0);

    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarPxa(res.filtro);
      });

    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.createPxa();
      });
  }

  filter = '';

  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }

  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  get(page) {
    this.spinner.show();
    if (page == 0 && this.paginatorpxa) {
      this.paginatorpxa.firstPage();
    }

    const params = {
      NUM_PAGINA: page,
      FILTRO: this.FILTER,
      NUM_ELEMENTOS: this.pageSize,
      EXCHANGE_ID: this.filtroExchangeId,
      DEPARTMENT_CODE: this.filtroDepartmentCode,
      SOURCE_APPLICATION: this.filtroSourceApplication,
      PXA: this.filtroPxa,
      FR: this.filtroFr,
      AG: this.filtroAg
    };

    this.gateway.get('getpxa', params).then((result: any) => {
      this.dataSource = result.rows || [];

      this.gateway.get('getpxacount', params).then((result2: any) => {
        this.resultsLength = result2.rows[0].total;
        this.spinner.hide();
      });
    }).catch((e) => {
      this.spinner.hide();
    });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  filtrarPxa(data) {
    this.FILTER = data;
    this.get(0);
  }

  aplicarFiltros() {
    this.get(0);
  }

  limpiarFiltros() {
    this.filtroExchangeId = '';
    this.filtroDepartmentCode = '';
    this.filtroSourceApplication = '';
    this.filtroPxa = '';
    this.filtroFr = '';
    this.filtroAg = '';
    this.filter = '';
    this.FILTER = null;
    this.get(0);
  }

  createPxa() {
    const user = this.localSave.get('usuarioPGV');
    const dialogRef = this.dialog.open(PxaDialogComponent, {
      maxWidth: '90vw',
      width: '650px',
      minHeight: '20vh',
      data: {
        operacion: 'Crear',
        regla: {},
        USUARIO_ID: user.IDU,
        USUARIO_NOMBRE: user.nombre + ' ' + (user.apellido || '')
      },
      disableClose: true,
      panelClass: 'pxa-dialog-panel'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

  edit(element) {
    const user = this.localSave.get('usuarioPGV');
    const dialogRef = this.dialog.open(PxaDialogComponent, {
      maxWidth: '90vw',
      width: '650px',
      minHeight: '20vh',
      data: {
        operacion: 'Editar',
        regla: element,
        USUARIO_ID: user.IDU,
        USUARIO_NOMBRE: user.nombre + ' ' + (user.apellido || '')
      },
      disableClose: true,
      panelClass: 'pxa-dialog-panel'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

  delete(element) {
    const user = this.localSave.get('usuarioPGV');
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '300px',
      data: {
        operacion: 'deletepxa',
        id: {
          ID: element.id,
          USUARIO_ID: user.IDU,
          USUARIO_NOMBRE: user.nombre + ' ' + (user.apellido || '')
        }
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.get(0);
    });
  }

  verAuditoria(element) {
    this.dialog.open(PxaAuditoriaComponent, {
      maxWidth: '90vw',
      width: '800px',
      minHeight: '20vh',
      data: { regla: element },
      disableClose: false,
      panelClass: 'pxa-auditoria-panel'
    });
  }

  abrirSimulador() {
    this.dialog.open(PxaSimuladorComponent, {
      maxWidth: '90vw',
      width: '650px',
      minHeight: '20vh',
      disableClose: false,
      panelClass: 'pxa-simulador-panel'
    });
  }

  cargaMasiva(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      this.snackbar.open('Solo puede seleccionar un archivo.', 'Cerrar', { duration: 3000 });
      return;
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      this.uploadfilePxa.nativeElement.value = null;

      const flag = dataexcel[0];
      if (flag[0] === 'PRIORITY' && flag[1] === 'EXCHANGE_ID' && flag[2] === 'DEPARTMENT_CODE'
        && flag[3] === 'SOURCE_APPLICATION' && flag[4] === 'EMPLOYEE_ID' && flag[5] === 'PXA'
        && flag[6] === 'FR' && flag[7] === 'AG' && flag[8] === 'FR_URL'
        && flag[9] === 'FR_MSG_CONSENT' && flag[10] === 'FR_MSG_REJECT') {

        const LISTA = [];
        let omitidos = 0;
        dataexcel.forEach(function (value, index) {
          if (index > 0 && (value[0] !== undefined && value[0] !== null && value[0] !== '')) {
            const frVal = (value[6] || 'N').toString().toUpperCase();
            if (frVal === 'S' && (!value[8] || !value[9] || !value[10])) {
              omitidos++;
              return;
            }
            LISTA.push({
              PRIORITY: value[0],
              EXCHANGE_ID: value[1] || null,
              DEPARTMENT_CODE: value[2] || null,
              SOURCE_APPLICATION: value[3] || null,
              EMPLOYEE_ID: value[4] || null,
              PXA: (value[5] || 'N').toString().toUpperCase(),
              FR: frVal,
              AG: (value[7] || 'N').toString().toUpperCase(),
              FR_URL: frVal === 'S' ? (value[8] || null) : null,
              FR_MSG_CONSENT: frVal === 'S' ? (value[9] || null) : null,
              FR_MSG_REJECT: frVal === 'S' ? (value[10] || null) : null
            });
          }
        });

        if (LISTA.length === 0) {
          const msg = omitidos > 0
            ? 'No se cargaron datos. ' + omitidos + ' filas omitidas (FR=S sin FR_URL, FR_MSG_CONSENT o FR_MSG_REJECT).'
            : 'El archivo no contiene datos.';
          this.snackbar.open(msg, 'Cerrar', { duration: 5000 });
          return;
        }

        this.spinner.show();
        const user = this.localSave.get('usuarioPGV');
        this.gateway.save('cargamasivapxa', {
          LISTA: LISTA,
          USUARIO_ID: user.IDU,
          USUARIO_NOMBRE: user.nombre + ' ' + (user.apellido || '')
        }).then((result: any) => {
          this.spinner.hide();
          let resMsg = 'Carga masiva: ' + result.insertados + ' insertados, ' + result.errores + ' errores de ' + result.total + ' registros.';
          if (omitidos > 0) {
            resMsg += ' ' + omitidos + ' omitidos (FR=S sin campos FR completos).';
          }
          this.snackbar.open(resMsg, 'Cerrar', { duration: 8000 });
          this.get(0);
        }).catch((e) => {
          this.spinner.hide();
          this.snackbar.open('Error en la carga masiva.', 'Cerrar', { duration: 3000 });
        });
      } else {
        this.snackbar.open('Formato de archivo no valido. Descargue la plantilla y siga el formato.', 'Cerrar', { duration: 6000 });
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  descargarPlantilla() {
    const headers: any[][] = [['PRIORITY', 'EXCHANGE_ID', 'DEPARTMENT_CODE', 'SOURCE_APPLICATION', 'EMPLOYEE_ID', 'PXA', 'FR', 'AG', 'FR_URL', 'FR_MSG_CONSENT', 'FR_MSG_REJECT']];
    const ejemplo: any[][] = [[1, 'FL1G', 'CONT1', 'T2', '9052179', 'S', 'S', 'N', 'https://fr.example.com', 'Cliente acepta FR', 'Cliente rechaza FR']];
    const data = headers.concat(ejemplo);

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Reglas PXA');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'plantilla_pxa.xlsx');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscriptioncreate) this.subscriptioncreate.unsubscribe();
  }
}
